import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DesignSystemModule } from '@peca/design-system';

export interface CardReconciledOrderProps {
  date: string;
  commerceReference: string;
  amount: number;
}

export interface CardReconciledNfProps {
  date: string;
  code: string;
  amount: number;
}

@Component({
  selector: 'peca-kanban-card-reconciled',
  imports: [CommonModule, DesignSystemModule],
  templateUrl: './kanban-card-reconciled.component.html',
  styleUrl: './kanban-card-reconciled.component.scss',
})
export class KanbanCardReconciledComponent {
  tittle = input<string>('');
  order = input<CardReconciledOrderProps>();
  nf = input<CardReconciledNfProps>();
  branchName = input<string>('');
  sendWithoutNf = input<boolean>(false);
  clickCard = output();
}
